import React, { Component, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import TimezoneDatePicker from './event_setup/timezone_date_picker'
import { GlgRoundedButtonIcon, GlgSelect, GlgTooltip, GlgTooltipIcon, GlgIcon } from 'SharedComponents'
import { NotificationManager } from 'react-notifications'
import Checkbox from './event_setup/checkbox'
import CalendarCustomInput from './event_setup/calendar_custom_input'
import SingleCriteriaOptions from './event_setup/single_criteria_options'
import DivisionsFlightsTable from './event_setup/divisions_flights_table'
import MultipleCriteriaTable from './event_setup/multiple_criteria_table'
import { getDateFormat, getDateTimeFormat, getDateUnixFormat } from '../../../shared/date_time_format.js'

const internationalize = (...args) => !window.I18n ? '' : window.I18n.t(...args)


const renderDivision = (division, inSet, props) => (
  <li key={division.id} className='division_container'>
    <div className={!inSet ? 'flex' : ''}>
      <label className='division_name'>{ division.name }</label>
      <span className='summary'>
        {
          division.summary.map((data, i) =>
            <>
              { i > 0 && <strong>{' | '}</strong> }
              <strong>{ data }</strong>
            </>,
          )
        }
      </span>
      {division.boundaries && (
        <span>
          {' | ' + division.boundaries}
        </span>
      )}
      {!inSet &&
        <GlgTooltip tooltip={division.delete_tooltip}>
          <a
            className={(division.name === 'All Golfers' ? 'right disabled' : 'right') + ' divisionset_action_icon'}
            onClick={() => {
              if (window.confirm( internationalize(('divisions.index.confirm_delete'), {name: division.name}) )) {
                props.removeDivision(division.id)
              }
            }}
          >
            <GlgIcon icon={'delete-item'}/>
          </a>
        </GlgTooltip>
      }
    </div>
  </li>
)

class DivisionsOverview extends Component {
  constructor(props){
    super(props)
  }

  componentDidMount() {
    window.NotificationManager = NotificationManager
  }

  render() {
    const divisionsWithoutDivisionset = this.props.content.divisions_without_divisionset
    const { divisionsets } = this.props.content
    const handleDeleteDivisionset = (id, name) => {
      if (window.confirm( internationalize(('divisions.index.confirm_delete'), {name: name}) )) {
        this.props.removeDivisionset(id)
      }
    }
    const renderAutofillToggle = (divisionset, id) => {
      const handleClick = async () => {
        const confirmMessage = internationalize(
          ('divisions.index.confirm_auto_fill'),
          { action: (divisionset.auto_refill_options.value) 
            ? internationalize('divisions.index.disable_auto_fill') 
            : internationalize('divisions.index.enable_auto_fill') },
        )
        if (!window.confirm(confirmMessage)) { return }
        this.props.setData([ 'divisionsets', id, 'auto_refill_options', 'loading' ], true)

        try {
          await this.props.toggleAutorefill(id)
        } finally {
          this.props.setData([ 'divisionsets', id, 'auto_refill_options', 'loading' ], false)
        }
      }

      const isLoading = divisionset.auto_refill_options.loading
      const disabled = divisionset.auto_refill_options.loading || !divisionset.auto_refill_options.enabled

      const toggleAutofillLink = (
        <a
          onClick={disabled ? undefined : handleClick}
          className={'toggle-autorefill refill-buttons btsp_orange_button' + (disabled ? ' disabled' : '')}
          >
          { isLoading ? internationalize('dashboard_plus.widgets.loading')
            : divisionset.auto_refill_options.value
              ? internationalize('divisions.index.disable_auto_fill')
              : internationalize('divisions.index.enable_auto_fill') }
        </a>
      )

      if (divisionset.auto_refill_options.enabled) {
        return toggleAutofillLink
      }

      return <GlgTooltip tooltip={divisionset.auto_refill_options.disabled_message}>{toggleAutofillLink}</GlgTooltip>
    }

    const autofillDateFormated = (date) => {
      const timeFormat = this.props.content.create_division.time_format
      const dateFormat = getDateUnixFormat(this.props.content.create_division.date_format, timeFormat)
      const timeZone = this.props.content.create_division.time_zone
      const formated = moment
        .unix(date)
        .tz(timeZone)
        .format(dateFormat)
      return (' | ' + internationalize('models.divisionset.autofill_until') + ' ' + formated)
    }

    return (
      <>
        <li className='add-division-button-container'>
          <GlgRoundedButtonIcon
            text={ internationalize('divisions.index.form_division.add_new_divisions') }
            icon={ 'gga-circle-plus' }
            onClick={ () => { this.props.setData([ 'addingDivision' ], true) }}
          />
        </li>
        { divisionsWithoutDivisionset.map(division => renderDivision(division, false, this.props)) }
        {
          Object.entries(divisionsets).map(([ id, divisionset ]) => (
            <li key={id} className='division_container'>
              <div className='divisionset_name flex'>
                { divisionset.name }
                { divisionset.division_options.date_for_autofill &&
                  autofillDateFormated(divisionset.division_options.date_for_autofill)
                }
                { divisionset.edit_options &&
                  <div className='add-margin-right-20'>
                    <GlgTooltip tooltip={divisionset.edit_options.message}>
                      <a 
                        className={`add-margin-left-10 divisionset_action_icon ${divisionset.edit_options.enabled ? '' : 'hidden'}`}
                        onClick={() => { this.props.editDivisionset(id) }}>
                          <GlgIcon icon='pencil-45-angle'/>
                      </a>
                    </GlgTooltip>
                  </div>
                }
                <div className='right divisionset_actions'>
                  { divisionset.show_auto_refill &&
                    <div className='add-margin-right-10'>
                      { renderAutofillToggle(divisionset, id) }
                    </div>
                  }
                  { divisionset.show_refill &&
                    <div className='add-margin-right-20'>
                      <a
                        onClick={() => this.props.refillDivisionset(id)}
                        className={'refill-buttons btsp_orange_button'}
                        >
                        { internationalize('divisions.index.refill') }
                      </a>
                    </div>
                  }
                  <div className='add-margin-top-2'>
                    <GlgTooltip tooltip={divisionset.delete_tooltip}>
                      <a
                        className={'divisionset_action_icon'}
                        onClick={() => handleDeleteDivisionset(id, divisionset.name)}
                      >
                        <GlgIcon icon={'delete-item'}/>
                      </a>
                    </GlgTooltip>
                  </div>
                </div>
              </div>
              <ul className='divisionset_divisions'> { divisionset.divisions.map(division => renderDivision(division, true, this.props)) } </ul>
            </li>
          ))
        }
      </>
    )
  }
}

const GolfersDivisionsCount = (props) => {
  const golfersDivisions = props.content.create_division.golfers_divisions
  const selectedHandicap = props.content.create_division.criteria.selected_handicap
  const autofill = props.content.create_division.golfers_divisions.auto_fill.selected
  const dateForAutofill = props.content.create_division.date_for_autofill
  const timeFormat = props.content.create_division.time_format.replace('A', 'aa')
  const dateFormatWithHour = getDateTimeFormat(props.content.create_division.date_format, timeFormat)
  const timeZone = props.content.create_division.time_zone
  const teeAndHole = props.content.create_division.tee_and_hole

  useEffect(() => {
    // compute division count errors
    const error = (parseInt(golfersDivisions.choices[golfersDivisions.selected]?.value) || 0 > 0) ? undefined : (
      golfersDivisions.selected === 'number_of_golfers' ? internationalize('divisions.number_golfers_per_division') : internationalize('divisions.number_of_division')
    )
    props.setError(GolfersDivisionsCount.name, error)

    if (selectedHandicap === 'by_playing_handicap' && !teeAndHole) {
      props.setError(GolfersDivisionsCount.name, internationalize('divisions.tee_or_hole_missing'))
    }

    return () => {
      // on unmount, retract errors
      props.setError(GolfersDivisionsCount.name, undefined)
    }
  }, [ golfersDivisions.selected, golfersDivisions.choices[golfersDivisions.selected]?.value, teeAndHole, selectedHandicap ])

  const selectCountType = (countType) => {
    props.setData([ 'create_division', 'golfers_divisions', 'selected' ], countType)
  }
  const setCount = (value) => {
    const countType = golfersDivisions.selected
    props.setData([ 'create_division', 'golfers_divisions', 'choices', countType, 'value' ], value)
    if (countType === 'number_of_golfers') {
      (props.content.create_division.divisions || []).forEach((_, i) => {
        props.setData([ 'create_division', 'divisions', i, 'golfers_per_division' ], value)
      })
    }
  }

  return (
    <div className='radio-option golfers_divisions_count add-margin-top-10'>
      <FirstRoundHIOptions {...props}/>
      <div className='btsp_horizontal_dotted_line'/>
      <div className='options-container vertical add-margin-top-20'>
        {
          Object.keys(golfersDivisions.choices).map((choiceKey, index) => {
            const choice = golfersDivisions.choices[choiceKey]
            return (
              <div className='grid' key={`golfers_divisions_${index}`}>
                <label className={`icheck-label ${choice.enabled ? '' : 'disabled'}`} htmlFor={`golfers_divisions_${index}`}>
                  <div className={`iradio_square-orange icheck-item ${choice.enabled ? '' : 'disabled'} ${choiceKey === golfersDivisions.selected ? 'checked' : ''}`}>
                    <input
                      id={`golfers_divisions_${index}`}
                      className='i-checks icheck-input'
                      type='radio'
                      name={`golfers_divisions_${index}`}
                      value={choiceKey}
                      onChange={ event => choice.enabled && selectCountType(event.target.value) }
                      checked={choiceKey === golfersDivisions.selected}
                      disabled={! choice.enabled}
                    />
                  </div>
                  <span>{choice.label}</span>
                </label>
                <input
                  className={`form-control ${choiceKey === golfersDivisions.selected ? '' : 'disabled'}`}
                  value={ choice.value }
                  onChange={ e => setCount(e.target.value) }
                  onBlur={ e => {
                    const count = Math.max(0, parseInt(e.target.value) || 0)
                    setCount(count)
                  }}
                  disabled={ choiceKey !== golfersDivisions.selected }
                />
              </div>
            )
          })
        }
        { golfersDivisions.selected === 'number_of_divisions' &&
          <div>
            <div className='add-margin-top-10'>
              <Checkbox
                key='maximum_handicap'
                label={selectedHandicap === 'combined_index_usga_index' ? golfersDivisions.maximum_handicap.label_handicap_index : golfersDivisions.maximum_handicap.label_playing_handicap}
                selected={golfersDivisions.maximum_handicap.selected}
                setOption={(v) => { 
                  props.setData( [ 'create_division', 'golfers_divisions', 'maximum_handicap', 'selected' ], v)
                  if (v) {
                    props.setData( [ 'create_division', 'golfers_divisions', 'same_index', 'selected' ], false)
                  } else {
                    props.setData( [ 'create_division', 'golfers_divisions', 'auto_fill', 'selected' ], false)
                  }
                }}
              />
            </div>
            { golfersDivisions.maximum_handicap.selected &&
              <div className='add-margin-top-10'>
                <Checkbox
                  key='auto_fill'
                  label={golfersDivisions.auto_fill.label}
                  selected={golfersDivisions.auto_fill.selected}
                  setOption={(v) => { props.setData( [ 'create_division', 'golfers_divisions', 'auto_fill', 'selected' ], v) }}
                />
              </div>
            }
            { autofill && 
              <div className='autofill_datepicker_container add-margin-top-10'>
                <div>
                  <label><b>{ internationalize('divisions.index.by_multiple_criteria.autofill_date') }</b></label>
                  <div>
                    <TimezoneDatePicker
                      showTimeSelect
                      targetTimezone={timeZone}
                      timeIntervals={60}
                      customInput={<CalendarCustomInput withTime/>}
                      selected={dateForAutofill}
                      dateFormat={dateFormatWithHour}
                      timeFormat={timeFormat}
                      minDate={new Date()}
                      onChange={(value) => {
                        props.setData([ 'create_division', 'date_for_autofill' ], value)
                      }}
                      onKeyDown={(e) => {
                        e.preventDefault()
                      }}
                    />
                  </div>
                </div>
                <div className='autofill_tooltip'>
                  <GlgTooltipIcon tooltip={ internationalize('divisions.index.by_multiple_criteria.autofill_tooltip') }/>
                </div>
              </div>
            }
          </div>
        }
        { (golfersDivisions.selected === 'number_of_golfers' ||
          (golfersDivisions.selected === 'number_of_divisions' && !golfersDivisions.maximum_handicap.selected)) &&
          <div className='add-margin-top-10'>
            <Checkbox
              key='same_index'
              label={selectedHandicap === 'combined_index_usga_index' ? golfersDivisions.same_index.label_hi : golfersDivisions.same_index.label_ph} 
              selected={golfersDivisions.same_index.selected}
              setOption={(v) => { props.setData( [ 'create_division', 'golfers_divisions', 'same_index', 'selected' ], v) }}
            />
          </div>
        }
      </div>
    </div>
  )
}

const PlayingHandicapSettings = (props) => {
  const createDivision = props.content.create_division
  const tees = createDivision.tees || {}
  const selectedTee = createDivision.tee_and_hole?.tee
  const holeType = createDivision.tee_and_hole?.hole
  const golferLabel = createDivision.golfer_label
  const genderAnswers = createDivision.gender_answers
  const adjustmentHandicap = createDivision.adjustment_handicap
  const genderAdjustmentHandicap = createDivision.gender_adjustment_handicap

  const handleTeeChange = (value) => {
    const hash = {
      tee: value,
      hole: Object.values(tees[value].holes)[0]?.value || '',
      virtual_id: Object.values(tees[value].holes)[0]?.virtual_id || '',
    }
    props.setData([ 'create_division', 'tee_and_hole' ], hash)
  }

  const handleHoleChange = (value) => {
    const hash = {
      tee: selectedTee,
      hole: value,
      virtual_id: tees[selectedTee]?.holes[value]?.virtual_id || '',
    }
    props.setData([ 'create_division', 'tee_and_hole' ], hash)
  }

  return (
    <div className='col-xs-12 no-padding'>
      <div className='btsp_horizontal_dotted_line'/>
      <div className='col-xs-12 col-lg-8 add-margin-top-20 no-padding'>
        <div className='course-and-tees col-xs-12 col-sm-6 add-margin-right-30 no-padding'>
          <div className='col-xs-12 add-margin-bottom-10 no-padding'>
            <label><b>{ internationalize('divisions.index.by_course_handicap.set_course_and_default_tee') }</b></label>
          </div>
          <div className='col-xs-12 add-margin-bottom-10 no-padding'>
            <GlgSelect
              key='default_tee'
              items={Object.values(tees)}
              placeholder={ internationalize('divisions.index.by_course_handicap.select_tee_required') }
              value={selectedTee}
              noPreFill={true}
              usePortal={true}
              searchable={true}
              height={38}
              onChange={(value) => handleTeeChange(value)}
            />
          </div>
          <div className='col-xs-12 add-margin-bottom-10 no-padding'>
            <GlgSelect
              key='default_hole_type'
              items={selectedTee ? Object.values(tees[selectedTee].holes) : []}
              placeholder={ internationalize('divisions.index.by_course_handicap.prompt_all_front_back') }
              value={holeType}
              noPreFill={true}
              usePortal={true}
              onChange={(value) => handleHoleChange(value)}
            />
          </div>
        </div>
        <div className='handicap-adjustment col-xs-12 col-sm-6 col-lg-5 no-padding'>
          <div className='col-xs-12 add-margin-bottom-10 no-padding'>
            <label><b>{ createDivision.handicap_adjustment_label }</b></label>
          </div>
          <div className='col-xs-12 no-padding'>
            <div className='col-xs-12 add-margin-bottom-5 no-padding'>
              <label>
                <input
                  type='number'
                  className='form-text form-control'
                  name='adjustment_handicap'
                  min={1}
                  max={100}
                  placeholder={100}
                  value={adjustmentHandicap}
                  onChange={ event => props.setData([ 'create_division', 'adjustment_handicap' ], event.target.value) }
                />
              </label>
              <span>{ golferLabel.golfers_no_gender }</span>
            </div>
            { genderAnswers.map(gender => (
              <div className='col-xs-12 add-margin-bottom-5 no-padding' key={`adjustment_handicap_${gender}`}>
                <label>
                  <input
                    type='number'
                    className='form-text form-control'
                    name={`adjustment_handicap_${gender}`}
                    min={1}
                    max={100}
                    placeholder={100}
                    value={genderAdjustmentHandicap ? genderAdjustmentHandicap[gender] : 100}
                    onChange={ event => props.setData([ 'create_division', 'gender_adjustment_handicap', gender ], event.target.value) }
                  />
                </label>
                <span>{ `% ${gender} gender` }</span>
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  )
}

const FirstRoundHIOptions = (props) => {
  const useFirstRoundHandicapOptions = props.content.create_division.first_round_hi_options.choices
  const useFirstRoundHandicap = props.content.create_division.first_round_hi_options.selected
  const selectedHandicap = props.content.create_division.criteria.selected_handicap
  const handicapText = selectedHandicap === 'by_playing_handicap'
    ? internationalize('divisions.index.by_multiple_criteria.playing_handicap', gon.whs_term_formats)
    : internationalize('divisions.index.by_multiple_criteria.handicap_index', gon.whs_term_formats)

  return (
    <>
      <div className='btsp_horizontal_dotted_line'/>
      <div className='add-margin-top-20 add-margin-bottom-20'>
        <div>
          <label><b>{ internationalize('divisions.index.by_multiple_criteria.first_round_handicap', { handicap: handicapText }) }</b></label>
        </div>
        <div className='options'>
          {
            useFirstRoundHandicapOptions.map((option) =>
              <label key={`first_round_hi_${option.value}`} className={`chip ${option.enabled ? '' : 'disabled '}${option.value === useFirstRoundHandicap ? 'chip-checked' : ''}`} htmlFor={`first_round_hi_${option.value}`}>
                <input
                  id={`first_round_hi_${option.value}`}
                  className='no-radio'
                  type='radio'
                  name={`first_round_hi_${option.value}`}
                  value={option.value}
                  onChange={ event => { option.enabled && props.setData([ 'create_division', 'first_round_hi_options', 'selected' ], event.target.value) }}
                  checked={useFirstRoundHandicap === option.value}
                  disabled={!option.enabled}
                />
                <span>{option.label}</span>
              </label>,
            )
          }
        </div>
      </div>
    </>
  )
}

class CreateDivision extends Component {
  constructor(props){
    super(props)
    this.state = {
      isDropdownOpen: false,
      dropdownPosition: { top: 0, left: 0 },
    }
    this.dropdownRef = React.createRef()
    this.checkboxRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('scroll', this.handleScroll, true)
    const widget = document.querySelector('#dashboard-page-widget-container')
    widget.scrollTo({ top: 0, behavior: 'smooth' })
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('scroll', this.handleScroll, true)
  }

  handleOutsideClick = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target) && !this.checkboxRef.current.contains(event.target)) {
      this.setState({ isDropdownOpen: false })
    }
  }

  handleScroll = () => {
    this.setState({isDropdownOpen: false})
  }

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }), this.updateDropdownPosition)
  }

  updateDropdownPosition = () => {
    if (this.dropdownRef.current) {
      const rect = this.dropdownRef.current.getBoundingClientRect()
      this.setState({
        dropdownPosition: {
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        },
      })
    }
  }

  render() {
    const getSelectedCriteria = () => {
      if (Array.isArray(criteria.selected)) {
        if (criteria.selected.length === 1) {
          const value = criteria.selected[0]
          return (value === 'by_gender' || value === 'by_age') ? 'by_multiple_criteria' : value
        } else if (criteria.selected.length === 0) {
          return ''
        }
        return 'by_multiple_criteria'
      }
      return criteria.selected || ''
    }

    const modalOpened = this.props.content.modal_opened
    const criteria = this.props.content.create_division.criteria
    const selectedCriteria = getSelectedCriteria()
    const autofillOptions = this.props.content.create_division.autofill_options.choices
    const autofill = this.props.content.create_division.autofill_options.selected
    const { isDropdownOpen, dropdownPosition } = this.state
    const customFields = this.props.content.create_division.custom_fields
    const multipleCriteriaCustomFields = this.props.content.create_division.multiple_criteria_custom_fields
    const customFieldAnswers = this.props.content.create_division.custom_field_answers
    const selectedCustomField = this.props.content.create_division.custom_fields.selected
    const divisionSource = this.props.content.create_division.division_source
    const eventDivisions = this.props.content.create_division.copy_event_divisions
    const roundDivisions = this.props.content.create_division.copy_round_divisions
    const rounds = this.props.content.create_division.rounds
    const selectedRound = this.props.content.create_division.rounds.selected
    const roundUsedCourses = this.props.content.create_division.round_used_courses
    const divisionsByCourse = this.props.content.create_division.divisions_by_course || {}
    const dateForAge = this.props.content.create_division.date_for_age
    const dateForAutofill = this.props.content.create_division.date_for_autofill
    const dateFormat = getDateFormat(this.props.content.create_division.date_format)
    const timeFormat = this.props.content.create_division.time_format.replace('A', 'aa')
    const dateFormatWithHour = getDateTimeFormat(this.props.content.create_division.date_format, timeFormat)
    const timeZone = this.props.content.create_division.time_zone
    const genderAnswers = this.props.content.create_division.gender_answers
    const availableMembersCount = this.props.content.create_division.available_members_count
    const divisionStartIndex = this.props.content.create_division.golfers_divisions.start_index
    const golfersPerDivision = this.props.content.create_division.golfers_divisions.choices.number_of_golfers.value
    const numberOfDivisions = this.props.content.create_division.golfers_divisions.choices.number_of_divisions.value
    const divisions = this.props.content.create_division.divisions || []
    const multipleCriteriaDivisions = this.props.content.create_division.multiple_criteria_divisions || []
    const useFirstRoundHI = this.props.content.create_division.first_round_hi_options.selected === 'true'
    const indexes = useFirstRoundHI
      ? this.props.content.create_division.first_round_indexes
      : this.props.content.create_division.available_members_index
    const byGolfersOrDivisionsCount = this.props.content.create_division.golfers_divisions.selected
    const byHandicap = selectedCriteria === 'by_handicap'
    const selectedHandicap = this.props.content.create_division.criteria.selected_handicap
    const handicapLabel = this.props.content.create_division.criteria.handicap_label
    const golferLabel = this.props.content.create_division.golfer_label
    const teeAndHole = this.props.content.create_division.tee_and_hole
    const editing = this.props.content.editingDivision

    const setDivisionData = (keys, value) => { this.props.setData([ 'create_division', 'divisions' ].concat(keys), value) }
    const setIndex = (value) => { this.props.setData([ 'create_division', 'available_members_index' ], value) }
    const setCount = (value) => {
      const golfersDivisions = this.props.content.create_division.golfers_divisions
  
      const countType = golfersDivisions.selected
      this.props.setData([ 'create_division', 'golfers_divisions', 'choices', countType, 'value' ], value)
      if (countType === 'number_of_golfers') {
        (this.props.content.create_division.divisions || []).forEach((_, i) => {
          this.props.setData([ 'create_division', 'divisions', i, 'golfers_per_division' ], value)
        })
      }
    }

    const handleSingleChange = (value) => {
      this.props.setData([ 'create_division', 'criteria', 'selected' ], value)
      this.props.setData([ 'create_division', 'criteria', 'selected_handicap' ], null)
      this.props.setData([ 'create_division', 'rounds', 'selected' ], null)
    }

    const handleMultipleChange = (value) => {
      const newSelected = Array.isArray(criteria.selected) ? [ ...criteria.selected ] : []
      if (newSelected.includes(value)) {
        newSelected.splice(newSelected.indexOf(value), 1)
      } else {
        newSelected.push(value)
      }
      this.props.setData([ 'create_division', 'criteria', 'selected' ], newSelected)
    }

    const handleHandicapChange = (value, label) => {
      const newSelected = Array.isArray(criteria.selected) ? [ ...criteria.selected ] : []
      if (criteria.selected_handicap === value) {
        this.props.setData([ 'create_division', 'criteria', 'selected_handicap' ], null)
        this.props.setData([ 'create_division', 'criteria', 'handicap_label' ], null)
        if (newSelected.includes('by_handicap')) {
          newSelected.splice(newSelected.indexOf('by_handicap'), 1)
        }
      } else {
        this.props.setData([ 'create_division', 'criteria', 'selected_handicap' ], value)
        this.props.setData([ 'create_division', 'criteria', 'handicap_label' ], label)
        if (!newSelected.includes('by_handicap')) {
          newSelected.push('by_handicap')
        }
      }
      this.props.setData([ 'create_division', 'criteria', 'selected' ], newSelected)
      this.setState({ isDropdownOpen: false })
    }

    return (
      <div className='add_division_container'>
        <h4 className='divisions-title'>{ internationalize('divisions.index.form_division.add_new_divisions') }</h4>
        <label className='divisions-label'><b>{ internationalize('divisions.index.form_division.create_divisions') }</b></label>
        <div className='chips-container'>
          <div className='multiple-selection-box'>
            <div className='chips-top'>
              <label><b>{ internationalize('divisions.index.add_new_division_or_refill.multiple_selection') }</b></label>
            </div>

            <div className='chips-box'>
              {
                criteria.choices.multiple_criteria.map((choice) => (
                  choice.value === 'by_handicap' ? (
                    <div ref={this.dropdownRef} key={'by_handicap_dropdown'}>
                      <div className='handicap-checkbox' ref={this.checkboxRef}>
                        <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                          <div className={`icheckbox_square-orange icheck-item ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'checked' : ''}`}>
                            <input
                              id={`criteria_${choice.value}`}
                              className='icheck-input'
                              type='checkbox'
                              name={`criteria_${choice.value}`}
                              value={choice.value}
                              onChange={() => this.toggleDropdown()}
                              checked={criteria.selected && criteria.selected.includes(choice.value)}
                              disabled={!choice.enabled}
                              readOnly
                            />
                          </div>
                          <span>{handicapLabel || choice.label}</span>
                          <span className='arrow-select'>{isDropdownOpen ? '▲' : '▼'}</span>
                        </label>
                      </div>

                      { isDropdownOpen && (
                         <div
                          className='handicap-dropdown'
                          style={{ top: `${dropdownPosition.top}px`, left: `${dropdownPosition.left}px` }}
                          > 
                            <label className='dropdown-label'>{ internationalize('divisions.index.add_new_division_or_refill.select_one') }</label>
                            { choice.handicaps.map((handicap) => (
                              <label key={`criteria_${handicap.value}`} className={`chip ${handicap.enabled ? '' : 'disabled '}${criteria.selected_handicap && criteria.selected_handicap === handicap.value ? 'chip-checked' : ''}`} htmlFor={`criteria_${handicap.value}`}>
                                <input
                                  id={`criteria_${handicap.value}`}
                                  className='no-radio'
                                  type='radio'
                                  name={`criteria_${handicap.value}`}
                                  value={handicap.value}
                                  onClick={event => handicap.enabled && handleHandicapChange(event.target.value, handicap.label)}
                                  checked={criteria.selected_handicap && criteria.selected_handicap === handicap.value}
                                  disabled={!handicap.enabled}
                                />
                                <span>{handicap.label}</span>
                              </label>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div key={`container_criteria_${choice.value}`}>
                      <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                        <div className={`icheckbox_square-orange icheck-item ${choice.enabled ? '' : 'disabled '}${criteria.selected && criteria.selected.includes(choice.value) ? 'checked' : ''}`}>
                          <input
                            id={`criteria_${choice.value}`}
                            className='icheck-input'
                            type='checkbox'
                            name={`criteria_${choice.value}`}
                            value={choice.value}
                            onChange={ event => choice.enabled && handleMultipleChange(event.target.value) }
                            checked={criteria.selected && criteria.selected.includes(choice.value)}
                            disabled={!choice.enabled}
                          />
                        </div>
                        <span>{choice.label}</span>
                      </label>
                    </div>
                  )
                ))
              }
            </div>
          </div>

          <div className='single-selection-box'>
            <div className='chips-top'>
              <label><b>{ internationalize('divisions.index.add_new_division_or_refill.single_selection') }</b></label>
            </div>

            <div className='chips-box'>
              {
                criteria.choices.single_criteria.map((choice) =>
                  <div key={`container_criteria_${choice.value}`}>
                    <label key={`criteria_${choice.value}`} className={`chip ${choice.enabled ? '' : 'disabled '}${choice.value === selectedCriteria ? 'chip-checked' : ''}`} htmlFor={`criteria_${choice.value}`}>
                      <input
                        id={`criteria_${choice.value}`}
                        className='no-radio'
                        type='radio'
                        name={`criteria_${choice.value}`}
                        value={choice.value}
                        onChange={ event => choice.enabled && handleSingleChange(event.target.value) }
                        checked={selectedCriteria === choice.value}
                        disabled={!choice.enabled}
                      />
                      <span>{choice.label}</span>
                    </label>
                  </div>,
                )
              }
            </div>
          </div>
        </div>

        {
          <div className='division_options'>
            { byHandicap && <GolfersDivisionsCount {...this.props} /> }
            { !Array.isArray(criteria.selected) &&
              <SingleCriteriaOptions
                selectedCriteria={selectedCriteria}
                divisionSource={divisionSource}
                eventDivisions={eventDivisions}
                roundDivisions={roundDivisions}
                rounds={rounds}
                selectedRound={selectedRound}
                roundUsedCourses={roundUsedCourses}
                divisionsByCourse={divisionsByCourse}
                setData={this.props.setData}
              />
            }
            { selectedCriteria === 'by_custom_field' &&
              <div>
                <div className='btsp_horizontal_dotted_line'/>
                <div className='col-xs-12 add-margin-top-15 no-padding'>
                  <div className='select_custom_field col-xs-12 col-sm-5 col-md-4 col-lg-3 no-padding'>
                    <label><b>{ internationalize('divisions.index.add_new_division_or_refill.choose_custom_field') }</b></label>
                    <GlgSelect
                      key='select_custom_field'
                      items={ customFields.choices }
                      placeholder={ internationalize('divisions.index.add_new_division_or_refill.choose_custom_field') }
                      value={ customFields.selected }
                      noPreFill={true}
                      usePortal={true}
                      onChange={ value => { this.props.setData([ 'create_division', 'custom_fields', 'selected' ], value) }}
                    />
                  </div>
                </div>
                { selectedCustomField && customFieldAnswers[selectedCustomField] &&
                  <div className='col-xs-12 col-sm-6 col-md-5 col-lg-4 add-margin-top-10 no-padding'>
                    <div className='table-responsive btsp_table_container'>
                      <table className='divisions_by_custom_field_table table with_striping tables_v2 table-striped btsp_table'>
                        <thead>
                          <tr>
                            <th>{ internationalize('divisions.index.by_multiple_criteria.division_name') }</th>
                            <th>{ internationalize('divisions.index.by_multiple_criteria.total') }</th>
                          </tr>
                        </thead>
                        <tbody>
                          { customFieldAnswers[selectedCustomField].answers?.map((answer, index) => {
                              const golfers = customFieldAnswers[selectedCustomField].no_golfers?.[answer] || 0
                              return ( golfers !== 0 &&
                                <tr key={`${answer}_${index}`}>
                                  <td>
                                    <input
                                      type='text'
                                      className='form-control division-name'
                                      defaultValue={`${answer} Division`}
                                    />
                                  </td>
                                  <td>{golfers} { golfers === 1 ? golferLabel.one : golferLabel.other }</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </div>
            }
            { byHandicap &&
              <>
                { selectedHandicap === 'by_playing_handicap' && <PlayingHandicapSettings {...this.props}/> }
                <div className='col-xs-12 no-padding'>
                  <div className='btsp_horizontal_dotted_line add-margin-bottom-20'/>
                  <DivisionsFlightsTable
                    category='division'
                    golferLabel={golferLabel}
                    withIndexUpTo={byHandicap && byGolfersOrDivisionsCount === 'number_of_divisions' && this.props.content.create_division.golfers_divisions.maximum_handicap.selected}
                    withNumberOfGolfers={byHandicap && byGolfersOrDivisionsCount === 'number_of_golfers'}
                    withGenders={false}
                    withAgeRange={false}
                    fixedItems={{
                      type: byHandicap ? (byGolfersOrDivisionsCount === 'number_of_divisions' ? 'fixed' : 'max_golfers') : 'disabled',
                      total: availableMembersCount,
                      startIndex: divisionStartIndex,
                      value: parseInt(byGolfersOrDivisionsCount === 'number_of_divisions' ? numberOfDivisions : golfersPerDivision) || 0,
                      dependencies: [ this.props.content.create_division.golfers_divisions, selectedHandicap ],
                      editing: editing,
                    }}
                    genderAnswers={genderAnswers}
                    items={divisions}
                    setItemData={setDivisionData}
                    setError={this.props.setError}
                    errorCheckingDependencies={[ selectedHandicap, this.props.content.create_division.divisions, this.props.content.create_division.golfers_divisions ]}
                    rowClass={selectedHandicap}
                    indexes={indexes}
                    setIndex={setIndex}
                    setCount={setCount}
                    golfersDivisionsFlights={this.props.content.create_division.golfers_divisions}
                  />
                </div>
              </>
            }
            { selectedCriteria === 'by_multiple_criteria' &&
              <>
                <div className='btsp_horizontal_dotted_line'/>
                <div className='autofill_area'>
                  <div>
                    <label><b>{ internationalize('divisions.index.by_multiple_criteria.autofill_divisions') }</b></label>
                  </div>
                  <div className='autofill_options'>
                    <div className='options'>
                      {
                        autofillOptions.map((option) =>
                            <label key={`autofill_${option.value}`} className={`chip ${option.enabled ? '' : 'disabled '}${option.value === autofill ? 'chip-checked' : ''}`} htmlFor={`autofill_${option.value}`}>
                              <input
                                id={`autofill_${option.value}`}
                                className='no-radio'
                                type='radio'
                                name={`autofill_${option.value}`}
                                value={option.value}
                                onChange={ event => { option.enabled && this.props.setData([ 'create_division', 'autofill_options', 'selected' ], event.target.value) }}
                                checked={autofill === option.value}
                                disabled={!option.enabled}
                              />
                              <span>{option.label}</span>
                            </label>,
                        )
                      }
                    </div>
                    { autofill === 'true' && 
                      <div className='autofill_datepicker_container'>
                        <div className='autofill_datepicker'>
                          <label><b>{ internationalize('divisions.index.by_multiple_criteria.autofill_date') }</b></label>
                          <div className='date_to_set_autofill'>
                            <TimezoneDatePicker
                              showTimeSelect
                              targetTimezone={timeZone}
                              timeIntervals={60}
                              customInput={<CalendarCustomInput withTime/>}
                              selected={dateForAutofill}
                              dateFormat={dateFormatWithHour}
                              timeFormat={timeFormat}
                              minDate={new Date()}
                              onChange={(value) => {
                                this.props.setData([ 'create_division', 'date_for_autofill' ], value)
                              }}
                              onKeyDown={(e) => {
                                e.preventDefault()
                              }}
                            />
                          </div>
                        </div>
                        <div className='autofill_tooltip'>
                          <GlgTooltipIcon tooltip={ internationalize('divisions.index.by_multiple_criteria.autofill_tooltip') }/>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                { selectedHandicap && <FirstRoundHIOptions {...this.props}/>}
                { selectedHandicap === 'by_playing_handicap' && <PlayingHandicapSettings {...this.props}/> }
                { criteria.selected.includes('by_age') &&
                  <div className='col-xs-12 no-padding'>
                    <div className='btsp_horizontal_dotted_line'/>
                    <div className='date_to_calculate_age'>
                      <label><b>{ internationalize('divisions.index.age_gender.date_to_calculate_age') }</b></label>
                      <DatePicker
                        customInput={<CalendarCustomInput />}
                        selected={ dateForAge && moment.unix(dateForAge).toDate() }
                        dateFormat={dateFormat}
                        onChange={(date) => {
                          date = date ? moment(date).unix() : date
                          this.props.setData([ 'create_division', 'date_for_age' ], date)
                        }}
                        onKeyDown={(e) => {
                          e.preventDefault()
                        }}
                      />
                    </div>
                  </div>
                }
                {
                  <div className='col-xs-12 no-padding'>
                    <div className='btsp_horizontal_dotted_line'/>
                    <MultipleCriteriaTable
                      criteria={criteria}
                      golferLabel={golferLabel}
                      teeAndHole={teeAndHole}
                      adjustmentHandicap={this.props.content.create_division.adjustment_handicap}
                      genderAdjustmentHandicap={this.props.content.create_division.gender_adjustment_handicap}
                      dateForAge={dateForAge}
                      useFirstRoundHI={this.props.content.create_division.first_round_hi_options.selected}
                      divisions={multipleCriteriaDivisions}
                      customFields={multipleCriteriaCustomFields}
                      customFieldAnswers={customFieldAnswers}
                      modalOpened={modalOpened}
                      closeModal={this.props.closeModal}
                      setData={this.props.setData}
                      updateDivisionRow={this.props.updateDivisionRow}
                      getMatchingMembers={this.props.getMatchingMembers}
                      leagueMembersCount={availableMembersCount}
                    />
                  </div>
                }
              </>
            }
          </div>
        }
      </div>
    )
  }
}

class EventSetupDivisions extends Component {
  constructor(props){
    super(props)
  }

  render() {
    const { title, dataChanged, saveInProgress, links, addingDivision, editingDivision } = this.props.content

    const errors = Object.values(this.props.content.create_division.errors || {}).filter(x => x)

    const handleCancel = () => {
      this.props.setData([ 'addingDivision' ], false)
      this.props.setData([ 'editingDivision' ], false)
      this.props.setData([ 'dataChanged' ], false)
      this.props.setData([ 'create_division', 'multiple_criteria_divisions' ], {})
      this.props.setData([ 'create_division', 'divisions' ], [])
      this.props.setData([ 'create_division', 'golfers_divisions', 'selected' ], null)
      this.props.setData([ 'create_division', 'golfers_divisions', 'maximum_handicap', 'selected' ], null)
      this.props.setData([ 'create_division', 'golfers_divisions', 'same_index', 'selected' ], null)
      this.props.setData([ 'create_division', 'golfers_divisions', 'auto_fill', 'selected' ], null)
      this.props.setData([ 'create_division', 'golfers_divisions', 'choices', 'number_of_divisions', 'value' ], null)
      this.props.setData([ 'create_division', 'golfers_divisions', 'choices', 'number_of_golfers', 'value' ], null)
      this.props.setData([ 'create_division', 'criteria', 'selected' ], null)
      this.props.setData([ 'create_division', 'criteria', 'selected_handicap' ], null)
      this.props.setData([ 'create_division', 'date_for_autofill' ], null)
    }

    return (
      <div className='widget-content-default widget-event-setup-divisions'>
        <div className='title'>
          { title }

          {
            dataChanged && (addingDivision || editingDivision) &&
              (() => {
                const saveButton = (
                  <a
                    onClick={saveInProgress || errors.length > 0 ? undefined : this.props.save}
                    className='btn btn-primary widget-white-title-button'
                    disabled={errors.length > 0}
                  >
                    { saveInProgress ? internationalize('dashboard_plus.widgets.saving') : links.save.name }
                  </a>
                )

                return errors.length > 0 ? <GlgTooltip tooltip={errors.join('\n')}>{saveButton}</GlgTooltip> : saveButton
              })()
          }
          {
            (addingDivision || editingDivision) &&
              <a
                onClick={() => handleCancel()}
                className='btn btn-primary widget-white-title-button'
              >
                { internationalize('buttons.cancel') }
              </a>
          }
        </div>

        <div className='content flex-list-layout'>
          <ul>
            {
              (addingDivision || editingDivision) ?
                <CreateDivision {...this.props} />
                :
                <DivisionsOverview {...this.props} />
            }
          </ul>
        </div>
      </div>
    )
  }
}

EventSetupDivisions.propTypes = {
  content: PropTypes.object,
  setData: PropTypes.func,
  save: PropTypes.func,
  setError: PropTypes.func,
  closeModal: PropTypes.func,
}
DivisionsOverview.propTypes = EventSetupDivisions.propTypes
CreateDivision.propTypes = EventSetupDivisions.propTypes
GolfersDivisionsCount.propTypes = EventSetupDivisions.propTypes
PlayingHandicapSettings.propTypes = EventSetupDivisions.propTypes
FirstRoundHIOptions.propTypes = EventSetupDivisions.propTypes

EventSetupDivisions.defaultProps = {
  content: {
    title: 'EVENT DIVISIONS',
    data: {},
  },
}

export default EventSetupDivisions
